import React from "react";
import styles from "./css/Slide.module.css";
import { motion } from "framer-motion";
import { useNavClick } from "../Header/navHelpers";

export default function Slide({ title, subtitle, image, ctaText, ctaLink }) {
    const handleNavClick = useNavClick();
    const isExternal = /^https?:\/\//i.test(ctaLink || "");

    return (
        <div className={styles.slide}>
            {/* Texto com gradiente animado e fade/slide-in */}
            <div className={styles.textContent}>
                <motion.h1
                    className={styles.title}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1.2 }}
                >
                    Gestão Inteligente com {title}
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1.5, delay: 0.3 }}
                >
                    {subtitle}
                </motion.p>

                <motion.a
                    href={ctaLink}
                    onClick={isExternal ? undefined : (e) => handleNavClick(e, ctaLink)}
                    target={isExternal ? "_blank" : undefined}
                    rel={isExternal ? "noopener noreferrer" : undefined}
                    className={styles.ctaButton}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.6 }}
                >
                    {ctaText}
                </motion.a>
            </div>

            {/* Imagem */}
            <motion.div
                className={styles.imageContainer}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2, delay: 0.4 }}
            >
                <img src={image} alt={title} className={styles.slideImage} />
            </motion.div>
        </div>
    );
}
